/**
 * Refactor ToDo:
 * - Remove unused functions
 * - Change BLEObservers and ExitObservers to camelCase
 * - Change file extension to .ts
 * - Add types to the file
 */

let BLEObservers = [];
let ExitObservers = [];
let infoObservers = [];

export const DEVICE_STATUS = {
  FRAME_ACCEPTED: 'frame_accepted',
  FRAME_NOT_ACCEPTED: 'frame_not_accepted',
  SDK_INITIALIZING: 'initializing',
  SDK_SCANNING: 'scanning_ssid',
  SDK_CONNECTING: 'connecting',
  DEVICE_EVENT: 'event',
  SDK_BLE_PERMISSION_DENIED: 'ble_permission_denied',
  SDK_ERROR_CONNECTION: 'error_connection',
  SDK_DISCONNECTED: 'disconnected',
  OPEN_ACK_4: 'open_init',
  OPEN_LATCH_RETRACTED_5: 'open_allowed',
  OPEN_RESULT_OK_6: 'open_success',
  OPEN_RESULT_KO_LATCH_NOT_RETRACTED_7: 'open_blocked',
  OPEN_RESULT_KO_DOOR_OPENING_NOT_DETECTED_8: 'open_timeout',
  OPEN_RESULT_KO_UNKNOWN_ERROR_9: 'open_error',
  CLOSE_RESULT_OK_10: 'close_detected',
  CLOSE_RESULT_KO_LATCH_STILL_RETRACTED_11: 'close_error',
  CLOSE_RESULT_KO_TIMEOUT_12: 'close_timeout',
  OPEN_RESULT_ACCESS_OK: 'open_access_success',
  OPEN_RESULT_ACCESS_KO: 'open_access_failure',
  OPEN_RESULT_ACCESS_UNAVAILABLE: 'open_access_unavailable'
};

function parseBLEEventPayload(status, payload) {
  if (status === DEVICE_STATUS.DEVICE_EVENT) {
    switch (payload) {
      case 1:
        return DEVICE_STATUS.FRAME_ACCEPTED;
      case 2:
      case 3:
        return DEVICE_STATUS.FRAME_NOT_ACCEPTED;
      case 4:
        return DEVICE_STATUS.OPEN_ACK_4;
      case 5:
        return DEVICE_STATUS.OPEN_LATCH_RETRACTED_5;
      case 6:
        return DEVICE_STATUS.OPEN_RESULT_OK_6;
      case 7:
        return DEVICE_STATUS.OPEN_RESULT_KO_LATCH_NOT_RETRACTED_7;
      case 8:
        return DEVICE_STATUS.OPEN_RESULT_KO_DOOR_OPENING_NOT_DETECTED_8;
      case 9:
        return DEVICE_STATUS.OPEN_RESULT_KO_UNKNOWN_ERROR_9;
      case 10:
        return DEVICE_STATUS.CLOSE_RESULT_OK_10;
      case 11:
        return DEVICE_STATUS.CLOSE_RESULT_KO_LATCH_STILL_RETRACTED_11;
      case 12:
      case 13:
      case 14:
        return DEVICE_STATUS.CLOSE_RESULT_KO_TIMEOUT_12;
      case 105:
        return DEVICE_STATUS.OPEN_RESULT_ACCESS_OK;
      case 106:
        return DEVICE_STATUS.OPEN_RESULT_ACCESS_KO;
      case 107:
        return DEVICE_STATUS.OPEN_RESULT_ACCESS_UNAVAILABLE;
    }
  }
  return status;
}

export const ApiWebApp = {
  lastInfo: null,

  bleStatus: function (status) {
    localStorage.setItem('bleStatus', status);
  },

  characteristicsSDK: function (characteristics) {
    // characteristics, array de strings separado por pipes
    // Por ejemplo: "lock_ble|access_ble"
    localStorage.setItem('characteristicsSDK', characteristics);
  },

  openLockStatus: function () {
    // Backward compatibility with old versions (Android SDK mwap <v3)
    // Silently ignore
  },

  // v3
  openBLEStatus: function (status, payload) {
    const parsedEvent = parseBLEEventPayload(status, parseInt(payload));
    BLEObservers.forEach((observer) => observer(parsedEvent));
  },

  // called by couriers webapp
  addBLEObserver: function (observer) {
    BLEObservers.push(observer);
  },

  removeBLEObservers: function () {
    BLEObservers = [];
  },

  info: function (sdkInfo) {
    let data;
    if (typeof sdkInfo === 'string') {
      data = JSON.parse(sdkInfo);
    } else if (typeof sdkInfo === 'object' && sdkInfo !== null) {
      data = sdkInfo;
    } else {
      // eslint-disable-next-line no-console
      console.error('sdkInfo must be an object or a valid JSON string.');
      return;
    }
    this.lastInfo = data;
    // eslint-disable-next-line no-console
    console.log(
      `SDK Info:
            - NWAP Version: ${data.nwap_version}
            - SDK Version: ${data.sdk_version}
            - OS Name: ${data.os_name}
            - OS Version: ${data.os_version}
            - Characteristics: ${data.characteristics}`
    );
    this.characteristicsSDK(data.characteristics);
    infoObservers.forEach((observer) => observer(data));
  },

  addInfoObserver: function (observer) {
    infoObservers.push(observer);
    // Replay last info to new observer
    if (this.lastInfo) {
      observer(this.lastInfo);
    }
  },

  exit: function () {
    // eslint-disable-next-line no-console
    console.log('Exit signal from SDK, observer:', ExitObservers);
    let handled = false;
    ExitObservers.forEach((observer) => {
      handled ||= observer();
    });
    return handled;
  },

  addExitObserver: function (observer) {
    ExitObservers.push(observer);
  },

  clearExitObservers: function () {
    ExitObservers = [];
  }
};
